/**
 * Asynchronously loads the component
 */

import { lazyLoad } from '../../../utils/loadable';

export const VenuePage = lazyLoad(
    () => import('./index'),
    (module) => module.VenuePage,
);
